export class Link {
    ruta?: string;
    isExterno?: boolean;
    abreSolapa?: boolean;
    tag?: string;

    constructor(ruta?: string, externo?: boolean, abreSolapa?: boolean, tag?: string) {
        this.ruta = ruta;
        this.isExterno = externo;
        this.abreSolapa = abreSolapa;
        this.tag = tag;
    }

    hasUrl(): boolean {
        return this.ruta != null && this.ruta.trim().length > 0;
    }

    static fromJsonObject(json: any): Link | undefined {
        if (json == null) return undefined;
        return new Link(json.ruta, json.isExterno, json.abreSolapa, json.tag);
    }
}
